<template>
  <div class="container">
    <i18n-t class="font40px text" :keypath="text" tag="div" scope="global">
      <template #first_hand_date>
        <span class="font64px highlight">{{ props.date }}</span>
      </template>
      <template #first_hand_type>
        <span class="font46px highlight pink">{{ props.game }}</span>
      </template>
      <template  #first_clash_date>
        <div v-if="game === 'KKClash'" class="font46px highlight">{{ props.date }}</div>
      </template>
      <template  #kkclash>
        <span v-if="game === 'KKClash'" class="font46px highlight">KKClash</span>
      </template>
    </i18n-t>
    <div class="handCards five" :class="`num${props.handCards ? props.handCards.length : '0'}`">
      <div v-for="index in props.handCards" :key="index" class="card" :class="`h-${cardMap(index)}`"></div>
      <img v-if="props.game === 'KKClash'" class="skChips" :src="require('@img/keyVisual/chips.png')"/>
    </div>
    <img class="gameType" :src="require(`@img/gameType/${props.game}.png`)">
  </div>
</template>
<script setup>
import { defineProps } from "vue";

const props = defineProps({
  text: String,
  date: String,
  game: String,
  handCards: Array,
});

function cardMap(c) {
  if (c === 1295) {
    return 53; //小王
  } else if (c === 1552) {
    return 54; //大王
  }

  const suitIndex = Math.floor(c / 256);
  const rowIndex = {
    1: 1,
    2: 2,
    3: 0,
    4: 3,
  }[suitIndex];
  const colIndex = (c % 256) - 2;

  return rowIndex * 13 + colIndex + 1;
}

// function handleBackgroundImage() {
//   const container = document.querySelector('.handCardImage')
//   container.style.backgroundImage = 'require("@/assets/img/keyVisual/bg_4_SpinUp.png")';
//   console.log(container.style.backgroundImage)
// }
// onMounted(() => {
//   handleBackgroundImage()
// })
// 0x050F, //小王
// 0x0610  //大王
// const cardsString = (c) => {
//     const suitIndex = Math.floor(c / 256)
//     // Suit: c / 256
//     const suitMap = {
//         1: "♦",
//         2: "♣",
//         3: "♥",
//         4: "♠",
//     }
//     const seqIndex = (c % 256) - 2
//     // Point: c % 256, Index: Point-2
//     const seq = ["2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K", "A"]
//     return `${suitMap[suitIndex]}${seq[seqIndex]}`
// }
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: left;
  position: relative;
  width: 100%;
  height: 780px;
  @media (max-width: $containerWidth) {
    height: pxToVw(780px);
  }

  .gameType {
    position: absolute;
    top: 4%;
    left: 0;
    z-index: -1;
  }
}

.text {
  margin: 15% 8% 0 8%;
  height: 670px;
  @media (max-width: $containerWidth) {
    height: pxToVw(670px);
  }
}

$cardRows: 13;
$cardWidth: 180px * 0.7;
$cardHeight: 235px * 0.7;

.handCards {
  position:relative;
  display: flex;
  justify-content: flex-end;
  white-space: nowrap;

  &.num2 {
    margin-bottom: 17%;
    margin-right: 37%;
    .card:nth-child(1) {
      
      transform: rotate(-10deg) translate(20%, -66%);
    }
    .card:nth-child(2) {
      transform: rotate(10deg) translate(-20%, -40%);
    }
  }

  &.num4 {
    margin-bottom: 24%;
    margin-right: 35%;
    .card:nth-child(1) {
      transform: rotate(-20deg) translate(40%, 0%);
    }
    .card:nth-child(2) {
      transform: rotate(-10deg) translate(20%, -20%);
    }
    .card:nth-child(3) {
      transform: rotate(10deg) translate(-20%, -20%);
    }
    .card:nth-child(4) {
      transform: rotate(20deg) translate(-40%, 0%);
    }
  }

  &.num5 {
    margin-bottom: 28%;
    margin-right: 31%;
    .card:nth-child(1) {
      transform: rotate(-25deg) translate(56%, 16%);
    }
    .card:nth-child(2) {
      transform: rotate(-15deg) translate(34%, -13%);
    }
    .card:nth-child(3) {
      transform: rotate(0deg) translate(0%, -27%);
    }
    .card:nth-child(4) {
      transform: rotate(15deg) translate(-34%, -15%);
    }
    .card:nth-child(5) {
      transform: rotate(25deg) translate(-57%, 13%);
    }
  }
  &.num6 {
    margin-bottom: 32%;
    margin-right: 36%;
    .card:nth-child(1) {
      transform: rotate(-30deg) translate(70%, 30%);
    }
    .card:nth-child(2) {
      transform: rotate(-18deg) translate(42%, -6%);
    }
    .card:nth-child(3) {
      transform: rotate(-6deg) translate(15%, -25%);
    }
    .card:nth-child(4) {
      transform: rotate(6deg) translate(-15%, -25%);
    }
    .card:nth-child(5) {
      transform: rotate(18deg) translate(-42%, -6%);
    }
    .card:nth-child(6) {
      transform: rotate(30deg) translate(-70%, 30%);
    }
  }
}

.skChips {
  width: 210px;
  position: absolute;
  bottom: 130px;
  right: 60px;
  @media (max-width: $containerWidth) {
    width: pxToVw(210px);
    bottom: pxToVw(130px);
    right: pxToVw(60px);
  }
}

.card {
  display: inline-block;
  margin: -1%;
  width: $cardWidth;
  height: $cardHeight;
  background-image: url("~@img/poker.png");
  background-repeat: no-repeat;

  $max: 54;

  @for $i from 1 through $max {
    &.h-#{$i} {
      $x: ($i - 1) % $cardRows * -$cardWidth;
      $y: floor(($i - 1) / $cardRows) * -$cardHeight +0.5px;
      background-position: $x $y;
      background-size: 13*100% 5*100%;
    }
  }

  @media (max-width: $containerWidth) {
    $minCardWidth: pxToVw($cardWidth);
    $minCardHeight: pxToVw($cardHeight);
    width: $minCardWidth;
    height: $minCardHeight;

    @for $i from 1 through $max {
      &.h-#{$i} {
        $x: ($i - 1) % $cardRows * - $minCardWidth;
        $y: floor(($i - 1) / $cardRows) * - $minCardHeight + pxToVw(0.5px);
        background-position: $x $y;
        background-size: calc(13*100%) calc(5*100%);
      }
    }

  }
}
</style>
